import { gql } from '@apollo/client';

export const CREATE_CARD = gql`
  mutation CreateCard {
    createCard {
      entity {
        status
        redirectUrl
      }
      errors {
        code
        message
        path
      }
    }
  }
`;

export const UPDATE_CARD = gql`
  mutation UpdateCard($id: ID!, $name: String, $active: Boolean) {
    updateCard(id: $id, name: $name, active: $active) {
      entity {
        status
        card {
          id
          name
          token
          pan
          expiry
          system
          iconUrl {
            url
          }
          issuer
          isActive
          isExpired
          isPrimary
        }
      }
      errors {
        code
        message
        path
      }
    }
  }
`;

export const DELETE_CARD = gql`
  mutation DeleteCard($id: ID!) {
    deleteCard(id: $id) {
      entity
      errors {
        code
        message
        path
      }
    }
  }
`;

export const SET_PRIMARY_CARD = gql`
  mutation SetPrimaryCard($id: ID!) {
    setPrimary(id: $id) {
      entity
      errors {
        code
        message
        path
      }
    }
  }
`;
